import global from "global";
import { ServiceError } from "../../../../../services/errors";
import dateTimeWrapper from "../../../../../dateTimeWrapper";
import isAppOnline from "../../../../../providers/applicationOnlineStatusProvider";
import { OFFLINE_ERROR_PAGE_DELAY_MS } from "../../../../../constants";

const requestRetryWrapper = async (
  requestProvider,
  onRetryFailure,
  retries,
  backoffArray = [0],
  backoffCount = 0
) => {
  retries--;
  const now = dateTimeWrapper();

  try {
    return await requestProvider();
  } catch (e) {
    if (!isAppOnline()) {
      return new Promise((_, reject) => {
        global.setTimeout(() => {
          reject(new ServiceError(e));
        }, OFFLINE_ERROR_PAGE_DELAY_MS);
      });
    }
    if (!(e instanceof ServiceError)) {
      throw e;
    }
    if (retries === 0) {
      return await Promise.reject(e);
    }

    onRetryFailure();

    const elapsedTime = dateTimeWrapper() - now;
    const backoffArrayIndex = Math.min(backoffCount, backoffArray.length - 1);
    const backoffValue = backoffArray[backoffArrayIndex];
    const backoffTime = Math.max(0, backoffValue - elapsedTime);

    return await new Promise(resolve =>
      global.setTimeout(
        () =>
          resolve(
            requestRetryWrapper(
              requestProvider,
              onRetryFailure,
              retries,
              backoffArray,
              backoffCount + 1
            )
          ),
        backoffTime
      )
    );
  }
};

export default requestRetryWrapper;
